import { render, staticRenderFns } from "./CertificateIcon.vue?vue&type=template&id=3bde882b&"
import script from "./CertificateIcon.vue?vue&type=script&lang=js&"
export * from "./CertificateIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports